import ClientFactory from '@/api/ClientFactory';
const FileApi = ClientFactory.get('files');

const state = {
    files:[],
    name:"File Name"
}

const actions = {
    async loadFiles({commit}) {
        commit('setFiles', await FileApi.get());
    }
}

const mutations = {
    setFiles: (state, response) => {
        const {
            data
        } = response;

        console.log(data)
        state.files = [...data];
    }
}

const getters = {

}

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
};